import { store } from '../store';

import * as analyticsManager from 'Utilities/analytics/analyticsManager';
import { getCurrentUserSessionId } from 'Utilities/authHelpers';
import { getRegionForCountry } from 'Utilities/dataHelpers';

import { ACCOUNT_TYPE_PAT, PATIENT, PROFESSIONAL } from 'Constants/accountTypes';
import { ANALYTIC_LDS_MODULE } from 'Constants/analyticsEventTypes';
import { AnalyticsActionType, AnalyticsTitleType } from 'Constants/analyticsEventTypes';

export const logAnalyticsEvent = ({
  action,
  eventTitle,
  code,
}: {
  action: AnalyticsActionType;
  eventTitle: AnalyticsTitleType;
  code?: string;
}): void => {
  const {
    user: { accountType, country, quickShare },
  } = store.getState();

  analyticsManager.LogEvent(eventTitle, {
    action,
    module: ANALYTIC_LDS_MODULE,
    userType: accountType === ACCOUNT_TYPE_PAT ? PATIENT : PROFESSIONAL,
    userRegion: getRegionForCountry(country),
    userCountry: country,
    libreDataShareCode: code || quickShare.code || '',
    sessionId: getCurrentUserSessionId(),
  });
};
